export default "__VITE_ASSET__d0852e8c__"